import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    price: null,
    isEligibleForLeadGuarantee: false,
    error: null,
});

const reducer = (state = initState(), action) => {
    switch (action.type) {
        case DispatchConstants.PAID_INCLUSION_DETAILS_SUCCESS:
            return {
                ...state,
                price: action.payload.price,
                isEligibleForLeadGuarantee: action.payload.isEligibleForLeadGuarantee,
            };
        case DispatchConstants.PAID_INCLUSION_DETAILS_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default reducer;
